import { Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
})
export class ToasterComponent implements OnInit {
  constructor(
    public snackBarRef: MatSnackBarRef<ToasterComponent>,
    @Inject(MAT_SNACK_BAR_DATA)
    public data: {
      status: string;
      message: string;
    }
  ) {}

  ngOnInit(): void {}

  alertIcon = () => {
    switch (this.data.status) {
      case 'SUCCESS':
        return '../../../assets/icones/check_circle.svg';
      case 'ERROR':
        return '../../../assets/icones/cancel.svg';
      case 'WARNING':
        return '../../../assets/icones/warning_white.svg';
      case 'INFO':
        return '../../../assets/icones/info.svg';

      default:
        return '../../../assets/icones/info.svg';
    }
  };

  closeToast() {
    this.snackBarRef.dismiss();
  }
}
